import clsx from "clsx";

type ChipProps = {
    text: string;
    testId?: string;
    className?: string;
};

export function Chip({ text, testId, className }: ChipProps) {
    return (
        <div
            className={clsx(
                "body-s rounded-lg bg-slate-200 px-2 py-1 text-slate-900",
                className,
            )}
            data-testid={testId}
        >
            {text}
        </div>
    );
}
